import React, { Component } from "react"
import { Tab, Tabs, TabList, TabPanel } from "react-tabs"
import styled from "@emotion/styled"
import theme from "../styles/theme"

const Background = styled.div`
  background: ${theme.color.ink};
  padding: 64px 32px 128px 32px;
`
const Container = styled.div`
  align-items: center;
  max-width: ${theme.maxwidth.default};
  margin: 0 auto;
  color: #fff;
  .react-tabs__tab-list {
    display: flex;
    justify-content: space-around;
    padding: 16px;
    flex-wrap: wrap;
    @media (max-width: ${theme.breakpoints.tablet}) {
      justify-content: flex-start;
      padding: 0;
      margin: 0 0 64px 0;
    }
    .react-tabs__tab {
      list-style: none;
      border-bottom: 2px solid transparent;
      cursor: pointer;
      user-select: none;
      @media (max-width: ${theme.breakpoints.tablet}) {
        padding: 16px;
        margin: 8px 0;
      }
      &.react-tabs__tab--selected {
        border-bottom: 2px solid ${theme.color.accent};
      }
    }
  }
  .react-tabs__tab-panel {
    max-width: 600px;
    h2 {
      color: #fff;
    }
  }
`
const Button = styled.a`
  border: none;
  padding: 8px 32px;
  background: ${theme.color.accent};
  color: ${theme.color.ink};
  border-radius: ${theme.border.default};
  text-decoration: none;
`

export default class TabbedContent extends Component {
  render() {
    return (
      <Background>
        <Container>
          <Tabs>
            <TabList>
              <Tab>For Startups</Tab>
              <Tab>For VCs, Accelerators and Incubators</Tab>
            </TabList>

            <TabPanel>
              <h2>Lets talk about how Stack can help your startup grow</h2>
              <p>
                We’ve helped hundreds of startups sell efficiently and scale
                rapidly via the Stack sales framework. Lets talk about how we
                can help you too.
              </p>
              <Button href="mailto:hello@stackglobal.io">Let's Talk</Button>
            </TabPanel>
            <TabPanel>
              <h2>Stack for VCs, Accelerators and Incubators</h2>
              <p>
                See how Stack works with VCs and Accelerators to assist their
                portfolio companies with their growth journey.
              </p>
              <Button href="mailto:hello@stackglobal.io">Let's Talk</Button>
            </TabPanel>
          </Tabs>
        </Container>
      </Background>
    )
  }
}
